const routes = [{
    path: '',
    component: () => import('@/shared/components/layout/Interno'),
    children: [
        {
            name: 'boletosAreaCliente',
            path: '/area_cliente/movimentacoes_financeiras',
            component: () => import('../views/Listar'),
        }
    ]
},
// GCK-20831: o detalhe da cobrança usa o shell próprio do portal (PortalLayout)
{
    name: 'visualizarAreaCliente',
    path: '/area_cliente/movimentacoes_financeiras/visualizar/:id',
    component: () => import('../views/Visualizar'),
}]

export default routes
